import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  addTableRow,
  deleteTableRow,
  getAboutUsFromStore,
  getAboutUsListFromDb,
  getCoversAndCoverTypes,
  getCoversAndCoverTypesFromStore,
  getSTCoptionsAboutUsSelected,
  getSTCoptionsCoversDynTableDetailsCover,
  getSTCoptionsCoversDynTableDetailsReason,
  getSTCoptionsCoversDynTableOrder,
  updateCoverInRow,
  updateReason,
  updateStcOptionsAboutUsSelected,
} from "../store/quotes";
import * as theme from "../theme";
import DeleteIcon from "@material-ui/icons/Delete";
import { PossibleApiStatusValues } from "../store/helperfuncs";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/styles";
import { getBrokerInformation } from "../store/broker";
import _ from "lodash";

const AboutUsSingleSelect = () => {
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;

  // Translation object for different languages
  const translations = {
    en: {
      selectAboutUs: 'Please select the relevant "About Us" content',
    },
    fr: {
      selectAboutUs:
        "Veuillez sélectionner le contenu « À propos de nous » pertinent",
    },
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: "7vh",
        paddingLeft: "9vmin",
        fontSize: "1.5vmin",
        paddingTop: "1vh",
      }}
    >
      <span style={{ fontFamily: "GibsonLightIt" }}>
        {translations[languagecode]?.selectAboutUs}
      </span>
      <AboutUsDropDown />
    </div>
  );
};

const AboutUsDropDown = () => {
  const dispatch = useDispatch();
  const aboutus = useSelector(getAboutUsFromStore);
  const { information } = useSelector(getBrokerInformation);
  const valuesfetch = useSelector(getSTCoptionsAboutUsSelected);

  useEffect(() => {
    if (aboutus === PossibleApiStatusValues.notstarted) {
      // get broker team from server
      let brokeragecode = null;
      // data gathering
      try {
        brokeragecode = information.brokerages[0].code;
      } catch (e) {
        console.log("Cannot get first brokerage code of the user");
      }

      dispatch(getAboutUsListFromDb({ brokeragecode }));
    }
  }, []);

  const CssTextField = withStyles({
    root: {
      "& label.Mui-focused": {
        color: "white",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "white",
      },
      "& .MuiInput-icon": {
        color: "white",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "white",
        },
        "&:hover fieldset": {
          borderColor: "white",
        },
        "&.Mui-focused fieldset": {
          borderColor: "white",
        },
      },
    },
    icon: {
      color: "white",
    },
  })(TextField);

  const useStyles = makeStyles({
    root: {
      color: "white",
      width: "20vw",
      borderRadius: 20,
      backgroundColor: theme.COLORS.primary_navyblue,
      fontFamily: "GibsonSemiBd",
      broder: "2px solid white",
      "& .MuiAutocomplete-listbox": {
        border: "2px solid grey",
        minHeight: 400,
        color: "green",
        fontSize: 18,
        //hover discussed above
        "& li": {
          //list item specific styling
          border: "2px solid green",
          borderRadius: 4,
        },
      },
    },
    outerRoot: {
      fontFamily: "GibsonSemiBd",
      border: 0,
      color: "white",
    },
    input: {
      color: "blue",
    },
    textfield: {
      "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
        color: "white",
      },
      "& .MuiButtonBase-root.MuiAutocomplete-popupIndicator": {
        color: "white",
      },
      "& .MuiInputBase-input.MuiAutocomplete-input": {
        color: "white",
      },
      "& #custom-autocomplete-label": {
        //or could be targeted through a class
        color: "brown",
      },
    },
  });

  const classes = useStyles();

  // const teamSelectedStoreValue = useSelector(getSTCoptionsMeetYourTeam);

  const onChangeHandle = (event, value) => {
    dispatch(updateStcOptionsAboutUsSelected({ selectedoption: value }));
  };

  return (
    <div style={{ paddingTop: "1vmin" }}>
      {aboutus === PossibleApiStatusValues.notstarted ? (
        <div></div>
      ) : aboutus === PossibleApiStatusValues.loading ? (
        <div></div>
      ) : (
        <div style={{ paddingTop: "1vmin", marginBottom: "2vmin" }}>
          <Autocomplete
            id={`ABOUTUS`}
            options={aboutus}
            getOptionLabel={(option) => option.title}
            onChange={onChangeHandle}
            value={valuesfetch}
            // PopperComponent={CustomPopper}
            classes={{
              root: classes.root,
            }}
            style={{ fontFamily: "GibsonSemiBd" }}
            renderInput={(params) => (
              <CssTextField
                {...params}
                variant="outlined"
                margin="dense"
                classes={{
                  root: classes.root,
                }}
                className={classes.textfield}
                // onFocus={() => {
                //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
                //     helpTipPB.VerticalHelpOrTipFncs.changeText(
                //       this.props.questionHint
                //     );
                //   }
                // }}
                // onBlur={() => {
                //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
                //     helpTipPB.VerticalHelpOrTipFncs.changeText("");
                //   }
                // }}
              />
            )}
          ></Autocomplete>
          {_.isEmpty(aboutus) ? (
            <div style={{ color: theme.COLORS.red_dot }}>
              Not find any about us? Inform your brokerage admin to add one!
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

export default AboutUsSingleSelect;
